'use client';
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import classNames from 'classnames';
import { ModalOverlay, useModal } from 'components/molecules/Modal/Modal';
import family from './Family.png';
import Translations from './i18n';
import Button from '$/components/Button';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

type FamilyTravelModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const FamilyTravelModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: FamilyTravelModalProps) => {
  const context = useClientContext();
  const staticText = getClientTranslations(Translations, context);

  // Use the modal hook for scroll locking and ESC key handling
  useModal({ isScrollLockActive: isOpen, onClose: onCancel });

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <ModalOverlay onClose={onCancel} />
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className={classNames(
          'fixed left-1/2 top-1/2 z-50 w-full max-w-[390px] overflow-hidden rounded-radius/card-inner shadow-xl',
          '-translate-x-1/2 -translate-y-1/2',
          'hidden lg:block',
        )}
      >
        <div className="bg-fill/card">
          <div className="flex flex-col items-center gap-spacing/gap/soft-12px p-spacing/padding/y-sm">
            {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
            <div className="flex size-25 items-center justify-center rounded-full bg-gradient-to-b from-[#e0f4f8] to-[#e8f5e9] p-spacing/padding/soft-8px">
              <CmsImage
                // eslint-disable-next-line tailwindcss/no-arbitrary-value
                className="size-[54px] object-cover object-top"
                src={family}
                alt="family pictogram"
                aria-hidden
                placeholder="blur"
                priority
                unoptimized
              />
            </div>

            <h2 className="text-center font-semibold text-text/primary text-font-size/subheading-1 leading-line-height/subheading-1">
              {staticText.familyModalHeadline}
            </h2>

            <p className="text-center font-medium text-text/secondary text-font-size/body-1 leading-line-height/body-1-relaxed">
              {staticText.familyModalBody}
            </p>
          </div>

          <div className="flex gap-spacing/gap/soft-12px border-t border-borders/default px-spacing/padding/y-sm py-spacing/gap/soft-12px bg-fill/card">
            <Button
              onClick={onCancel}
              styleType="primary"
              variant="outline"
              className="flex-1"
            >
              {staticText.familyModalNo}
            </Button>
            <Button
              onClick={onConfirm}
              styleType="primary"
              className="flex-1"
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
            >
              {staticText.familyModalYes}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
